/**
 * @format
 * @Description: 我的消息请求层
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import Request from 'utils/request';

export default class MyMessageServ {
  static addOrganization(params) {
    return Request({
      url: `api/user/v1/organization/org/info`,
      method: 'POST',
      data: params
    });
  }
  static getTree() {
    return {
      url: 'api/user/v1/organization/list',
      method: 'GET',
      data: {
        filter: {}
      }
    };
  }
  static getList() {
    return {
      method: 'get',
      url: `api/message/v1/message/list`
    };
  }
  static notify() {
    return {
      method: 'put',
      url: `api/message/v1/message/notify`
    };
  }
}



// WEBPACK FOOTER //
// ./src/pages/MessageManage/MyMessage/MyMessageServ.js